export const ROOT = '/';
export const MAIN_PAGE_ROUTE = `${ROOT}`;
export const NATIVE_APP_ERROR = `${ROOT}native`;
export const NOT_FOUND = `${ROOT}not-found`;
